import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';

export const ZakaznikKontakt = {
	name: NAME,
	apiProvider,
	router,
};
